import React, { useEffect, useState } from "react";
import NewProjectTemplate from "./new-project.template";
import { getInventorySearchAPI } from "../Home-Page/home-page.component.service";

const NewProjectComponent = () => {
    const [inventoryItems, setInventoryItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchKeyword, setSearchKeyword] = useState("");

    const onLoad = async (payload = {}) => {
        try {
            setLoading(true);
            const response = await getInventorySearchAPI(payload);
            if (response.status) {
                setInventoryItems(response.data.result);
            } else {
                setError(response.message || "Failed to fetch inventory items");
            }
        } catch (err) {
            setError("An error occurred while fetching inventory items");
            console.error("Error fetching inventory items:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (payload) => {
        setSearchKeyword(payload.keyword || "");
        onLoad(payload);
    };
    const handleProduct = (item) => {
        if (item && item.part_number) {
            onLoad({ keyword: item.part_number });
        }
    };

    useEffect(() => {
        onLoad();
    }, []);
// console.log({inventoryItems})
    const templateData = {
        inventoryItems,
        loading,
        error,
        searchKeyword
    };

    const templateEvents = {
        handleSearch,
        handleProduct,
    };

    return <NewProjectTemplate 
        templateData={templateData}
        templateEvent={templateEvents}
    />;
};

export default NewProjectComponent;